//SASS file
// import './themeSwitcher';
import './header';
// import './search';
import './progressBar';
import './megaMenu';
import './post';

import "../scss/main.scss";

document.querySelectorAll('*').forEach(el => {
    if (el.scrollWidth > document.documentElement.clientWidth) {
        console.log(el.tagName, el.id ? '#'+el.id : '', el.className ? '.'+el.className : '');
    }
});